/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IAddSuggestionResponse extends IMessage {
	id: string;
	authorId: string;
	type: string;
	createdAt?: string;
	data: string;
	hasComments?: boolean;
	state?: string;
	attributes: string | null;
}

export default class AddSuggestionResponse extends Message {
	public readonly createdAt?: Date;

	public static readonly DESCRIPTOR_NAME: string = 'TrackChangesAddSuggestionResponse';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			authorId: {
				type: 'string',
				id: 2
			},
			type: {
				type: 'string',
				id: 3
			},
			createdAt: {
				type: 'string',
				id: 4
			},
			data: {
				type: 'string',
				id: 5
			},
			hasComments: {
				type: 'bool',
				id: 6
			},
			state: {
				type: 'string',
				id: 7
			},
			attributes: {
				type: 'string',
				id: 8
			}
		}
	};

	public constructor(
		public readonly id: string,
		public readonly authorId: string,
		public readonly type: string,
		createdAt?: string,
		public readonly hasComments?: boolean,
		public readonly state?: string,
		public readonly data: Record<string, unknown> | null = {},
		public readonly attributes: Record<string, unknown> | null = null
	) {
		super();

		this.createdAt = createdAt ? new Date( createdAt ) : undefined;
	}

	public toJSON(): IAddSuggestionResponse {
		return {
			id: this.id,
			authorId: this.authorId,
			type: this.type,
			createdAt: this.createdAt?.toISOString(),
			data: JSON.stringify( this.data ),
			hasComments: this.hasComments,
			state: this.state,
			attributes: JSON.stringify( this.attributes )
		};
	}

	public static fromJSON( data: IAddSuggestionResponse ): AddSuggestionResponse {
		return new AddSuggestionResponse(
			data.id,
			data.authorId,
			data.type,
			data.createdAt,
			data.hasComments,
			data.state,
			JSON.parse( data.data ),
			data.attributes ? JSON.parse( data.attributes ) : null
		);
	}
}
